import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["launchBtn"];
  static outlets = ["tourguide"];

  connect() {
    if (this.hasTourguideOutlet) {
      this.launchBtnTarget.classList.remove("d-none");
    }
  }

  launchBtnClick() {
    this.tourguideOutlet.launchBtnClick();
  }
}
